import CountryRegionNames from './CountryRegionNames';

export default countryCode => CountryRegionNames[countryCode];
